import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Input } from '@eika/input';

import gyldigEpostFormat from '../../infra/format';
import { useTranslation } from '../../translations';
import { KontaktinformasjonFormData } from '../kontaktinformasjon/kontaktinformasjon';

const MedlaantakerKontaktinfo: FC = () => {
    const { kontaktinfoMedlaantaker, validationMessage } = useTranslation();
    const {
        register,
        formState: { errors },
    } = useFormContext<KontaktinformasjonFormData>();

    return (
        <>
            <Input
                inputMode="numeric"
                label={kontaktinfoMedlaantaker.labelMobil}
                className="max-width-200"
                error={errors.medlaantaker?.tlf?.message}
                {...register('medlaantaker.tlf', {
                    required: `${validationMessage.requiredValue}`,
                    minLength: { value: 8, message: `${validationMessage.patternTlf}` },
                })}
            />
            <Input
                inputMode="email"
                label={kontaktinfoMedlaantaker.labelEpost}
                className="max-width-400"
                error={errors.medlaantaker?.epost?.message}
                {...register('medlaantaker.epost', {
                    required: `${validationMessage.requiredValue}`,
                    pattern: {
                        value: gyldigEpostFormat,
                        message: `${validationMessage.patternEpost}`,
                    },
                })}
            />
        </>
    );
};

export default MedlaantakerKontaktinfo;
